/* ==========================================================================
   sd-collection.js - native facet disclosures
   --------------------------------------------------------------------------
   This code originally lived in a {% javascript %} block inside
   templates/collection.liquid. Shopify rejects that outright:
   "Liquid syntax error: Unknown tag 'javascript'". Both {% javascript %} and
   {% stylesheet %} are valid ONLY in sections/, blocks/ and snippets/, never
   in a template.

   Scope note: this file handles the native Search and Discovery facet form
   only, which exists on the collection template and nowhere else. The generic
   "submit this form when it changes" behaviour used by the sort control and
   the cart lives in sd-2026.js, because it is needed on more than one
   template and duplicating it would guarantee the two copies drift.

   ENHANCEMENT ONLY. The facets are plain checkboxes in a GET form with a
   submit button inside <noscript>, so filtering works with scripting off.
   ========================================================================== */

(function () {
  'use strict';

  var facetForm = document.getElementById('SdCollFilters');
  if (!facetForm) return;

  var toggles = facetForm.querySelectorAll('[data-sd-facet-toggle]');
  for (var i = 0; i < toggles.length; i++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    })(toggles[i]);
  }

  facetForm.addEventListener('change', function () { facetForm.submit(); });
})();